import "../base-layout/common.css";
import "lc-jquery";

// Export the public interface of the module.
// Can be an object or a function(), which will have 'new' called on it
module.exports = {};

require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/src/shared_modules/dashboard-nav/dashboard-nav.less');